import { useEffect, useState } from "react";
import axios from "axios";

function AdminQuestionManager() {

  const [exams, setExams] = useState([]);
  const [filteredExams, setFilteredExams] = useState([]);

  const [filterType, setFilterType] = useState("all");

  const [loading, setLoading] = useState(false);


  // ========================================
  // FETCH EXAMS
  // ========================================
  const fetchExams = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        "https://du-an-trac-nghiem.onrender.com/api/admin/exams"
      );

      setExams(res.data);
      setFilteredExams(res.data);

    } catch (error) {

      console.error("FETCH EXAMS ERROR:", error);

      alert("Không thể tải danh sách đề");

    } finally {

      setLoading(false);

    }

  };


  // ========================================
  // LOAD DATA
  // ========================================
  useEffect(() => {

    fetchExams();

  }, []);



  // ========================================
  // FILTER
  // ========================================
  useEffect(() => {

    if (filterType === "all") {

      setFilteredExams(exams);

    } else {

      const filtered = exams.filter(
        (exam) =>
          exam.exam_type &&
          exam.exam_type.toLowerCase() ===
          filterType.toLowerCase()
      );

      setFilteredExams(filtered);

    }

  }, [filterType, exams]);



  // ========================================
  // DELETE EXAM
  // ========================================
  const handleDelete = async (testId) => {

    const confirmDelete = window.confirm(
      `Are you sure you want to delete the question? ${testId}?`
    );

    if (!confirmDelete) return;


    try {

      await axios.delete(
        `https://du-an-trac-nghiem.onrender.com/api/admin/exams/${testId}`
      );

      alert("Deleted topic successfully!");

      fetchExams();

    } catch (error) {

      console.error("DELETE ERROR:", error);

      alert("Delete topic failed!");

    }

  };



  return (

    <div style={styles.container}>

      <h1 style={styles.title}>
        Exam management
      </h1>


      {/* FILTER */}
      <div style={styles.filterContainer}>

        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={styles.select}
        >

          <option value="all">
            All
          </option>

          <option value="reading">
            Reading
          </option>

          <option value="listening">
            Listening
          </option>

          <option value="writing">
            Writing
          </option>

        </select>

      </div>



      {/* TABLE */}
      {loading ? (

        <p>Đang tải dữ liệu...</p>

      ) : (

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>
                Test ID
              </th>

              <th style={styles.th}>
                Topic type
              </th>

              <th style={styles.th}>
                Title
              </th>

              <th style={styles.th}>
                Year
              </th>

              <th style={styles.th}>
                Audio
              </th>

              <th style={styles.th}>
                Image
              </th>

              <th style={styles.th}>
                Act
              </th>

            </tr>

          </thead>


          <tbody>

            {filteredExams.length === 0 ? (

              <tr>

                <td
                  colSpan="7"
                  style={styles.noData}
                >
                  Không có dữ liệu
                </td>

              </tr>

            ) : (

              filteredExams.map((exam) => (

                <tr key={exam.test_id}>

                  <td style={styles.td}>
                    {exam.test_id}
                  </td>

                  <td style={styles.td}>
                    {exam.exam_type || "N/A"}
                  </td>

                  <td style={styles.td}>
                    {exam.title || "Không có tiêu đề"}
                  </td>

                  <td style={styles.td}>
                    {exam.year || "N/A"}
                  </td>

                  <td style={styles.td}>

                    {exam.audio_url ? (

                      <a
                        href={exam.audio_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Audio
                      </a>

                    ) : (

                      "NULL"

                    )}

                  </td>

                  <td style={styles.td}>

                    {exam.image_url ? (

                      <a
                        href={exam.image_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Image
                      </a>

                    ) : (

                      "NULL"

                    )}

                  </td>

                  <td style={styles.td}>

                    <button
                      style={styles.deleteButton}
                      onClick={() =>
                        handleDelete(exam.test_id)
                      }
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      )}

    </div>

  );

}



const styles = {

  container: {
    padding: "30px",
    fontFamily: "Arial"
  },

  title: {
    marginBottom: "20px"
  },

  filterContainer: {
    marginBottom: "20px"
  },

  select: {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "6px"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  th: {
    border: "1px solid #ccc",
    padding: "12px",
    backgroundColor: "#f5f5f5"
  },

  td: {
    border: "1px solid #ccc",
    padding: "12px",
    textAlign: "center"
  },

  noData: {
    padding: "20px",
    textAlign: "center"
  },

  deleteButton: {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer"
  }

};


export default AdminQuestionManager;